import { defineComponent as o, createBlock as n, openBlock as r, unref as p, mergeProps as m, withCtx as c, createElementVNode as a } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconRocket",
  __name: "IconRocket",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const t = l;
    return (u, e) => (r(), n(p(d), m(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        a("path", { d: "M16.913 9.945a2 2 0 1 1-2.829-2.829 2 2 0 0 1 2.829 2.83" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M21.834 6.552c.464-2.574-1.783-4.82-4.356-4.356L13.89 2.843a3.304 3.304 0 0 0-1.75.915l-1.15 1.15-3.836-.549a2.25 2.25 0 0 0-1.909.636L2.677 7.564a1.75 1.75 0 0 0 .684 2.897l1.557.52-.557.555a.75.75 0 0 0 0 1.06l7.071 7.072a.75.75 0 0 0 1.061 0l.556-.556.52 1.556a1.75 1.75 0 0 0 2.897.684l2.568-2.568a2.25 2.25 0 0 0 .636-1.91l-.548-3.835 1.15-1.15a3.303 3.303 0 0 0 .915-1.75l.647-3.587m-4.037 7.813-3.562 3.56.756 2.269a.25.25 0 0 0 .414.098l2.568-2.569a.75.75 0 0 0 .212-.636l-.388-2.722m1.414-3.536a1.804 1.804 0 0 0 .5-.956l.647-3.588a2.25 2.25 0 0 0-2.614-2.613l-3.588.647a1.805 1.805 0 0 0-.956.5l-7.248 7.248 6.01 6.01 7.249-7.248M6.942 5.844l2.723.389-3.562 3.561-2.267-.756a.25.25 0 0 1-.098-.414l2.568-2.568a.75.75 0 0 1 .636-.212",
          "clip-rule": "evenodd"
        }, null, -1),
        a("path", { d: "M7.297 16.733a.5.5 0 0 0-.707 0L3.76 19.56a.5.5 0 1 0 .707.707l2.829-2.828a.5.5 0 0 0 0-.707m-2.12-1.414a.5.5 0 0 1 .707.707l-1.757 1.757a.5.5 0 1 1-.707-.707l1.757-1.757m3.748 3.042a.5.5 0 0 0-.707 0L6.46 20.116a.5.5 0 1 0 .707.707l1.756-1.756a.5.5 0 0 0 0-.707" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
